import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=7a1803fa&scoped=true&"
import script from "./BaseLayout.vue?vue&type=script&lang=js&"
export * from "./BaseLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=7a1803fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1803fa",
  null
  
)

export default component.exports